import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import { v4 } from 'uuid';
import { useSearchContext } from '../../../searchContext/SearchContextProvider.js';
import SearchResultAnalyticsWrapper from '../SearchResultAnalyticsWrapper.js';
import { ANALYTICS_WRAPPER_CLASS, ANALYTICS_RESULT_CLASS } from '../../../util/analyticsConstants.js';
import localize from '../../../util/localize.js';
import { useFlyoutContext } from './SearchFlyout.js';
import { ListItem, FlexBox, Link, Span } from '@vp/swan';
import { useRecentSearch } from '../../../localStorage/useRecentSearch.js';

var _excluded = ["result", "resultId", "children", "landingUrl", "a11yLabel", "isCustomerWork", "isCustomerResult"];
var FlyoutResult = function FlyoutResult(_ref) {
  var result = _ref.result,
    resultId = _ref.resultId,
    children = _ref.children,
    landingUrl = _ref.landingUrl,
    a11yLabel = _ref.a11yLabel,
    isCustomerWork = _ref.isCustomerWork,
    isCustomerResult = _ref.isCustomerResult,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useFlyoutContext = useFlyoutContext(),
    siteAnalyticsEventName = _useFlyoutContext.siteAnalyticsEventName,
    analyticsQueryString = _useFlyoutContext.analyticsQueryString;
  var _useSearchContext = useSearchContext(),
    handleKeyDown = _useSearchContext.handleKeyDown,
    preventBlur = _useSearchContext.preventBlur,
    query = _useSearchContext.query,
    locale = _useSearchContext.locale;
    _useSearchContext.applicationName;
  var _useState = useState(v4()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState('standard'),
    _useState4 = _slicedToArray(_useState3, 2),
    background = _useState4[0],
    setBackground = _useState4[1];
  var _useRecentSearch = useRecentSearch(),
    addRecentSearch = _useRecentSearch.addRecentSearch;
  var appendAnalyticsQuery = function appendAnalyticsQuery(url) {
    return url + (url.includes('?') ? '&' : '?') + analyticsQueryString;
  };
  var sendFlyoutAnalytics = function sendFlyoutAnalytics(evt) {
    var appRoot = evt.currentTarget.closest(".".concat(ANALYTICS_WRAPPER_CLASS));
    var resultWrapper = evt.currentTarget.closest(".".concat(ANALYTICS_RESULT_CLASS));
    var results = appRoot.getElementsByClassName(ANALYTICS_RESULT_CLASS);
    var resultPosition = Array.from(results).indexOf(resultWrapper);
    if (window.tracking && siteAnalyticsEventName) {
      window.tracking.track(siteAnalyticsEventName, {
        category: 'Internal Search',
        label: query,
        eventDetail: "".concat(window.location.pathname, ";").concat(landingUrl, ";").concat(results.length, ";").concat(resultPosition + 1)
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(ListItem, _extends({
    marginY: 0,
    paddingY: 0
  }, otherProps, {
    textAlign: 'center',
    role: "option",
    id: id
  }), /*#__PURE__*/React__default.createElement(SearchResultAnalyticsWrapper, {
    resultId: resultId,
    result: result
  }, /*#__PURE__*/React__default.createElement(FlexBox, {
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "nowrap",
    my: 0
  }, /*#__PURE__*/React__default.createElement(Link, {
    className: "search-flyout-item search-flyout-item-link",
    skin: isCustomerWork ? 'standard' : 'unstyled',
    href: appendAnalyticsQuery(landingUrl || result.landingUrl),
    onKeyDown: function onKeyDown(evt) {
      if (evt.code === 'Enter') {
        sendFlyoutAnalytics(evt);
      }
      handleKeyDown(evt);
    },
    onClick: function onClick(evt) {
      addRecentSearch(query);
      sendFlyoutAnalytics(evt);
    },
    onMouseDown: preventBlur,
    "aria-label": a11yLabel,
    width: "full-width",
    backgroundColor: isCustomerResult ? 'strong' : background,
    onMouseEnter: function onMouseEnter() {
      setBackground('strong');
    },
    onMouseLeave: function onMouseLeave() {
      setBackground('standard');
    },
    p: 0,
    m: 0,
    style: {
      fontSize: isCustomerWork ? '12px' : '16px'
    }
  }, /*#__PURE__*/React__default.createElement(FlexBox, {
    alignItems: "center"
  }, children, result.inStock === false && /*#__PURE__*/React__default.createElement(Span, {
    display: "block",
    textAlign: "left",
    textColor: "subtle"
  }, /*#__PURE__*/React__default.createElement(Span, {
    fontSize: "xsmall",
    textColor: "standard",
    pr: 2
  }, "\u2022"), localize('outOfStock', locale)))))));
};

export { FlyoutResult as default };
//# sourceMappingURL=FlyoutResult.js.map
